import { FC } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { CountryFlag } from 'ui/CountryFlag';

type TSupportedCountryCardProps = {
	code: string;
	name: string;
};

export const SupportedCountryCard: FC<TSupportedCountryCardProps> = ({ code, name }) => {
	return (
		<Card variant="outlined" sx={{ borderRadius: '12px', borderColor: '#afc9db' }}>
			<CardContent sx={{ p: '10px!important' }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
					<CountryFlag
						countryCode={code}
						sx={{
							width: 40,
							height: 28,
							backgroundSize: 'cover',
							borderRadius: '6px',
							border: '1px solid #afc9db',
						}}
					/>
					<Box sx={{ minWidth: 0, p: 0, m: 0, display: 'flex', flexDirection: 'column', gap: 0 }}>
						<Typography
							variant="overline"
							color="text.secondary"
							sx={{ fontSize: '0.8rem', lineHeight: '1.2' }}
						>
							{code}
						</Typography>
						<Typography
							variant="h6"
							sx={{ fontWeight: 700, color: '#016193', fontSize: '1.1rem', lineHeight: '1.2' }}
						>
							{name}
						</Typography>
					</Box>
				</Box>
			</CardContent>
		</Card>
	);
};
